'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _AccessibleButton = require('./AccessibleButton');

var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _Analytics = require('../../../Analytics');

var _Analytics2 = _interopRequireDefault(_Analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createReactClass2.default)({
    displayName: 'RoleButton',

    propTypes: {
        size: _propTypes2.default.string,
        tooltip: _propTypes2.default.bool,
        action: _propTypes2.default.string.isRequired,
        mouseOverAction: _propTypes2.default.string,
        label: _propTypes2.default.string.isRequired,
        iconPath: _propTypes2.default.string,
        className: _propTypes2.default.string
    },

    getDefaultProps: function getDefaultProps() {
        return {
            size: "25",
            tooltip: false
        };
    },

    getInitialState: function getInitialState() {
        return {
            showTooltip: false
        };
    },

    _onClick: function _onClick(ev) {
        ev.stopPropagation();
        _Analytics2.default.trackEvent('Action Button', 'click', this.props.action);
        _dispatcher2.default.dispatch({ action: this.props.action });
    },

    _onMouseEnter: function _onMouseEnter() {
        if (this.props.tooltip) this.setState({ showTooltip: true });
        if (this.props.mouseOverAction) {
            _dispatcher2.default.dispatch({ action: this.props.mouseOverAction });
        }
    },

    _onMouseLeave: function _onMouseLeave() {
        this.setState({ showTooltip: false });
    },

    render: function render() {
        var TintableSvg = _index2.default.getComponent("elements.TintableSvg");

        var tooltip = void 0;
        if (this.state.showTooltip) {
            var Tooltip = _index2.default.getComponent("elements.Tooltip");
            tooltip = _react2.default.createElement(Tooltip, { className: 'mx_RoleButton_tooltip', label: this.props.label });
        }

        var icon = this.props.iconPath ? _react2.default.createElement(TintableSvg, { src: this.props.iconPath, width: this.props.size, height: this.props.size }) : undefined;

        var classNames = ["mx_RoleButton"];
        if (this.props.className) {
            classNames.push(this.props.className);
        }

        return _react2.default.createElement(
            _AccessibleButton2.default,
            { className: classNames.join(" "),
                onClick: this._onClick,
                onMouseEnter: this._onMouseEnter,
                onMouseLeave: this._onMouseLeave,
                'aria-label': this.props.label
            },
            icon,
            tooltip
        );
    }
}); /*
    Copyright 2017 Vector Creations Ltd
    
    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at
    
        http://www.apache.org/licenses/LICENSE-2.0
    
    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
    */

module.exports = exports['default'];
//# sourceMappingURL=ActionButton.js.map